import { render } from "./UnsavedTemplateModal.vue?vue&type=template&id=2ce2b15b&scoped=true"
import script from "./UnsavedTemplateModal.vue?vue&type=script&lang=js"
export * from "./UnsavedTemplateModal.vue?vue&type=script&lang=js"

import "./UnsavedTemplateModal.vue?vue&type=style&index=0&id=2ce2b15b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce2b15b"]])

export default __exports__